import { Modal, ModalBody, ModalFooter } from "shared/UI/Modal/Modal";
import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";

export type LeaveModalProps = {
  onConfirm: Function;
  onClose: Function;
};

export const LeaveModal = ({ onConfirm, onClose }: LeaveModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal title={t("leaderboards.leave.title")} width="xs" close={() => onClose()} hideDismiss>
      <ModalBody>
        {t("leaderboards.leave.description")}
      </ModalBody>
      <ModalFooter>
        <Button text={t("leaderboards.leave.confirmButton")} onClick={() => onConfirm()} />
        <Button text={t("leaderboards.leave.closeButton")} variant="text" onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  );
};
